import React from 'react';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';

const MOCK_UPCOMING = [
  { id: '1', payee: 'Rent', amount: 1500, dueDate: '1 Apr 2026' },
  { id: '2', payee: 'Council Tax', amount: 142, dueDate: '15 Apr 2026' },
  { id: '3', payee: 'Broadband', amount: 32, dueDate: '28 Apr 2026' },
];

export default function UpcomingPayments({ formatCurrency }) {
  return (
    <div className="rounded-xl border border-slate-200/80 dark:border-slate-600 bg-white dark:bg-slate-800 p-4 shadow-sm">
      <div className="flex items-center gap-2 mb-3">
        <CalendarDaysIcon className="h-5 w-5 text-slate-500 dark:text-slate-400" />
        <h3 className="text-sm font-semibold text-slate-900 dark:text-white">Upcoming payments</h3>
      </div>
      <ul className="space-y-2">
        {MOCK_UPCOMING.map((item) => (
          <li key={item.id} className="flex items-center justify-between gap-3 py-2 border-b border-slate-100 dark:border-slate-700 last:border-0 last:pb-0">
            <div>
              <p className="text-sm font-medium text-slate-900 dark:text-slate-100">{item.payee}</p>
              <p className="text-xs text-slate-500 dark:text-slate-400">Due {item.dueDate}</p>
            </div>
            <p className="text-sm font-semibold text-slate-900 dark:text-white">{formatCurrency(item.amount)}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
